<!-- @format -->

<template>
	<div class="platform-head-message">
		<div>
			<el-popover
				v-model:visible="popoverVisible"
				placement="bottom-end"
				width="400"
				trigger="click"
				popper-class="header-message-popper"
			>
				<template #reference>
					<el-button class="btn-text can-hover" link>
						<el-badge :max="99" :value="getMessageInfo.count" class="elBadgeitem">
							<el-icon size="24" color="rgb(255 255 255 / 30%)"><Bell /></el-icon>
						</el-badge>
					</el-button>
				</template>
				<div class="header-message-content">
					<div class="header-message-content-title">
						<el-tag class="news_title"> 内部消息 ({{ getMessageInfo.count }})</el-tag>
						<span class="platform-more-message" @click="clickMore">更多</span>
					</div>

					<div style="height: 250px">
						<el-scrollbar style="height: 100%; width: 100%" wrap-class="platform-scrollbar-wrapper ">
							<div class="platform-list-bordered">
								<ul
									v-for="(message, index) in getMessageInfo.list"
									:key="index"
									class="platform-list-item"
									@click="handleInteriorClick(message)"
								>
									<li style="cursor: pointer">
										<div class="platform-message-circle">
											<div class="platform-message-circle-small" />
											<div class="platform-message-circle-big" />
										</div>
										<span class="platform-item-main">
											<span>{{ message.title }}</span>
											<p style="margin: 4px 0">{{ message.createTime }}</p>
										</span>
									</li>
								</ul>
							</div>
						</el-scrollbar>
					</div>
				</div>
			</el-popover>
		</div>

		<!-- 消息明细 -->
		<inner-detail-dialog
			:id="editId"
			:visible="dialogFormVisible"
			title="信息明细"
			:detail-data="formDetailData"
			inside
			readonly
			@callback="getLoadDataMain"
			@close="(visible) => (dialogFormVisible = visible)"
		/>
	</div>
</template>

<script>
	import { getEnvUrlByUrl } from '@power/runtime-vue3';
	import InnerDetailDialog from './detail/dialog.vue';
	import { $utils } from '@/utils/publicUtils';
	import { updateMessageState as markRead } from '@/api/message/index';
	import { useMessageStoreWithOut } from '@/store/modules/message';

	const messageStore = useMessageStoreWithOut();

	const ENABLE_REFRESH_MESSAGE = false;
	const REFRESH_MESSAGE_TIME = 10000;

	export default {
		components: {
			InnerDetailDialog,
		},
		data() {
			return {
				editId: '',
				dialogFormVisible: false,
				formDetailData: {},
				popoverVisible: false,
				intervalAction: null,
				intervalTimes: 3,
			};
		},
		computed: {
			getMessageInfo() {
				return messageStore.msgHeaderInfo;
			},
		},
		created() {
			this.loadData();
		},
		mounted() {
			this.refreshData();
		},
		// 实例销毁前去除定时器
		beforeUnmount() {
			if (this.intervalAction) {
				clearInterval(this.intervalAction);
				this.intervalAction = null;
			}
		},
		methods: {
			refreshData() {
				if ($utils.toBoolean(ENABLE_REFRESH_MESSAGE, true)) {
					this.intervalAction = setInterval(() => {
						this.loadData();
					}, REFRESH_MESSAGE_TIME);
				}
			},
			// 加载数据
			loadData() {
				messageStore.updateMsgHeaderData();
			},
			getLoadDataMain() {
				this.handleAlreadyRead();
			},

			// 标记为已读
			handleAlreadyRead() {
				markRead({ ids: this.editId })
					.then(() => {
						this.loadData();
						messageStore.updateHomeMsgList();
						messageStore.updateHomeMsgCount();
					})
					.catch(() => {});
			},
			handleInteriorClick(message) {
				this.editId = message.id;
				this.formDetailData = message;
				this.popoverVisible = false;
				this.dialogFormVisible = true;
			},
			clickMore() {
				this.popoverVisible = false;
				// 更多消息
				const url = `/powerbase/platform/messages/inner/receive?hidePcLayoutHeader=1&hidePcLayoutMenu=1`;
				console.log(getEnvUrlByUrl(url));
				window.open(getEnvUrlByUrl(url));
			},
		},
	};
</script>
<style lang="scss" scoped>
	.platform-head-message {
		margin-right: 20px !important;

		.el-button .i-icon svg {
			left: -1px !important;
		}

		.el-button.is-link {
			color: #005bb8;
		}

		.el-button.is-link:focus,
		.el-button.is-link:hover {
			color: #005bb8;
		}

		.btn-text {
			.el-icon {
				vertical-align: middle;
			}

			.el-icon :hover {
				color: var(--theme-header-center-menu-item-color);
			}
		}
	}
</style>
<style lang="scss">
	.elBadgeitem {
		.el-badge__content {
			border: none;
		}
	}

	.platform-more-message {
		margin-top: 5px;
		float: right;
		font-weight: 500;
		cursor: pointer;
		font-size: 14px;
		color: #165dff;
	}

	.header-message-popper {
		padding: 0 !important;

		.header-message-content {
			padding: 0 !important;
			background: #fff !important;

			.header-message-content-title {
				font-weight: 600;
				padding: 18px 20px;
				border-bottom: 1px solid #e4e7ed;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			.news_title {
				display: inline-table;
				font-size: 14px;
				padding: 5px 16px;
				border-radius: 20px;
				border: 0px;
				color: #165dff;
			}
		}

		.message-more {
			padding: 15px 0;
			text-align: center;
			border-top: 1px solid #ebeef5;
		}

		.el-card__header {
			font-size: 14px;
			border-bottom: 1px solid #e5e6eb;
			padding: 10px 20px 10px 14px;

			.header-title-other {
				font-weight: 600;
			}
		}

		.platform-list-item {
			border-bottom: none !important;
			padding: 5px 10px;
			list-style-type: none;

			&:hover {
				background: #f7f8fb;
				color: #4e5969 !important;
				border-radius: 4px;
			}
		}

		.platform-list-bordered {
			padding: 10px 10px;
		}

		.platform-item-main {
			display: inline-block;
			padding-left: 26px;
		}

		.platform-message-circle {
			position: relative;
			box-sizing: border-box;
			width: 20px;
			top: 10px;

			.platform-message-circle-small {
				width: 16px;
				height: 16px;
				border: 7px solid #ffd1d0;
				border-radius: 50%;
				position: absolute;
				margin: auto; /*以下五个属性为水平垂直居中的方法*/
				left: 0;
				top: 0;
				right: 0;
				bottom: 0;
				box-sizing: border-box;
			}

			.platform-message-circle-big {
				width: 8px;
				height: 8px;
				border: 4px solid #f54a45;
				border-radius: 50%;
				position: absolute;
				margin: auto; /*以下五个属性为水平垂直居中的方法*/
				left: 0;
				top: 0;
				right: 0;
				bottom: 0;
				box-sizing: border-box;
			}
		}

		.el-scrollbar__bar {
			right: 0;
		}
	}
</style>
